// extracted by mini-css-extract-plugin
export default {"modalBody":"modalBody-zT0zV","body":"body-M4l7e","header":"header-jgRhN"};